import {
  SET_HEADER_FORM,
  CLEAR_HEADER_FORM_STATE
} from '../mutationTypes'

const state = {
  form: {},
  comparatorForm: {}
}

const actions = {
  setHeaderForm (store, payload) {
    if (payload && Object.keys(payload).length) {
      let promises = []
      for (let i in payload) {
        if (!(payload[i] && payload[i].value)) continue
        let model
        switch (i) {
          case 'vendor':
            store.dispatch('storeLastSearchResults', { entityType: 'vendors', mutation: 'RECEIVE_VENDORS' })
              .then(() => {
                model = store.getters.getVendorById(payload[i].value)
                if (model && Object.keys(model).length) {
                  promises.push(
                    store.dispatch('findDependencies', { vendors: [model] })
                      .then(p => Promise.all(p))
                      .catch(e => console.log(e))
                  )
                }
              })
            break
          case 'customer':
            store.dispatch('storeLastSearchResults', { entityType: 'customers', mutation: 'RECEIVE_CUSTOMER' })
              .then(() => {
                model = store.getters.getCustomerById(payload[i].value)
                if (model && Object.keys(model).length) {
                  promises.push(
                    store.dispatch('findDependencies', { customers: [model] })
                      .then(p => Promise.all(p))
                      .catch(e => console.log(e))
                  )
                }
              })
            break
          case 'batch':
            store.dispatch('storeLastSearchResults', { entityType: 'batches', mutation: 'RECEIVE_BATCHES' })
              .then(() => {
                model = store.getters.getBatchById(payload[i].value)
                if (model && Object.keys(model).length) {
                  promises.push(
                    store.dispatch('findDependencies', { batches: [model] })
                      .then(p => Promise.all(p))
                      .catch(e => console.log(e))
                  )
                }
              })
            break
        }
      }
    }
    this.commit(SET_HEADER_FORM, payload)
  },
  clearHeaderFormState () {
    this.commit(CLEAR_HEADER_FORM_STATE)
    return true
  }
}

const getters = {
  getHeaderForm: (state) => {
    return state.form || {}
  },
  getHeaderFieldByName: (state) => (query) => {
    return state.form[query] ? state.form[query] : {}
  }
}

const mutations = {
  [SET_HEADER_FORM] (state, payload) {
    let tmpForm = Object.assign({}, state.form)
    for (let p in payload) {
      if (payload[p] && payload[p].hasOwnProperty('value')) {     // payload[p] is a { label: 'foo', value: 'bar' }  object
        tmpForm[p] = Object.assign({}, payload[p])
      } else {                                      // payload[p] has a value which is not an object
        tmpForm[p] = payload[p]
      }
    }
    state.form = Object.assign({}, tmpForm)
  },
  [CLEAR_HEADER_FORM_STATE] (state) {
    state.form = Object.assign({})
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
